// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2jOgp","content":"RecentSearches_content__2VAbr"};